module.exports = __webpack_public_path__ + "img/traveling_man.1ee39f10.png";